import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '中间件实例',
    type: 'VR_DEPLOYED_MIDINS',
}
